import React from 'react';
import { Box, Modal, Typography, CircularProgress } from '@mui/material';
import { colors } from '../../../../../helpers/colors';
import { useGetFaceUrl } from './api';

/**
 * EmployeeFacePhotoView
 * ---------------------
 * Displays an employee's enrolled face photo in a modal, using the same
 * useGetFaceUrl hook as EmployeeFaceEnroll (single source of truth for
 * fetching the signed S3 URL).
 */
const EmployeeFacePhotoView = ({ open, employeeId, employeeName, onClose }) => {
  const { photoUrl, hasPhoto, isLoading } = useGetFaceUrl(
    open ? employeeId : null,
  );

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: 380,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: '8px',
          p: 3,
        }}
      >
        <Box sx={{ display: 'flex', marginBottom: '1em' }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontWeight: 600 }}>
              Enrolled Photo — {employeeName}
            </Typography>
          </Box>
          <i
            className="las la-times"
            style={{ fontSize: '1.5em', color: colors.grey, cursor: 'pointer' }}
            onClick={onClose}
          />
        </Box>

        <Box
          sx={{
            width: '100%',
            height: 260,
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {isLoading && <CircularProgress size={28} />}

          {!isLoading && !hasPhoto && (
            <Typography
              sx={{
                color: colors.red,
                fontSize: 14,
                px: 2,
                textAlign: 'center',
              }}
            >
              No enrolled photo found for this employee.
            </Typography>
          )}

          {!isLoading && hasPhoto && (
            <img
              src={photoUrl}
              alt={employeeName}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default EmployeeFacePhotoView;
